/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTEzLjUgMTAuNVY3LjVIOC41VjUuNUgxMS41VjAuNUg0LjVWNS41SDcuNVY3LjVIMi41VjEwLjVIMC41VjE1LjVINi41VjEwLjVIMy41VjguNUgxMi41VjEwLjVIOS41VjE1LjVIMTUuNVYxMC41SDEzLjVaTTUuNSAxLjVIMTAuNVY0LjVINS41VjEuNVpNNS41IDE0LjVIMS41VjExLjVINS41VjE0LjVaTTE0LjUgMTQuNUgxMC41VjExLjVIMTQuNVYxNC41WiIgZmlsbD0iaW5oZXJpdCIvPg==";